import React from 'react';
import { Instagram, MessageCircle, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-brand-cream py-16" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-185">
          <div className="col-span-1 md:col-span-2" data-id="element-186">
            <a href="#" className="text-4xl font-serif font-semibold tracking-wide text-brand-cream block mb-6" data-id="element-187">
              na.lilu
            </a>
            <p className="text-brand-cream/70 max-w-sm font-light leading-relaxed" data-id="element-188">
              Преміальний український бренд жіночого одягу. Елегантність, якість
              та сучасна жіночність у кожній нитці.
            </p>
          </div>

          <div data-id="element-189">
            <h4 className="font-serif text-xl mb-6" data-id="element-190">Швидкі посилання</h4>
            <ul className="space-y-3 text-brand-cream/70 font-light" data-id="element-191">
              <li data-id="element-192">
                <a href="#catalog" className="hover:text-white transition-colors" data-id="element-193">
                  Каталог
                </a>
              </li>
              <li data-id="element-194">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-195">
                  Про нас
                </a>
              </li>
              <li data-id="element-196">
                <a href="#reviews" className="hover:text-white transition-colors" data-id="element-197">
                  Відгуки
                </a>
              </li>
              <li data-id="element-198">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-199">
                  Контакти
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-200">
            <h4 className="font-serif text-xl mb-6" data-id="element-201">Контакти</h4>
            <ul className="space-y-4 text-brand-cream/70 font-light" data-id="element-202">
              <li data-id="element-203">
                <a href="tel:+380964797313" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-204">
                  <Phone className="w-4 h-4" data-id="element-205" />
                  +380 96 479 7313
                </a>
              </li>
              <li data-id="element-206">
                <a href="https://t.me/username" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-207">
                  <MessageCircle className="w-4 h-4" data-id="element-208" />
                  Telegram
                </a>
              </li>
              <li data-id="element-209">
                <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-210">
                  <Instagram className="w-4 h-4" data-id="element-211" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-cream/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-brand-cream/50 font-light" data-id="element-212">
          <p data-id="element-213">&copy; {new Date().getFullYear()} na.lilu. Всі права захищені.</p>
          <div className="flex gap-6" data-id="element-214">
            <a href="#" className="hover:text-white transition-colors" data-id="element-215">
              Політика конфіденційності
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-216">
              Умови надання послуг
            </a>
          </div>
        </div>
      </div>
    </footer>;
}